__turbopack_context__.v({
  "arrow": "select-module-scss-module__RDB_da__arrow",
  "empty": "select-module-scss-module__RDB_da__empty",
  "hide": "select-module-scss-module__RDB_da__hide",
  "icon": "select-module-scss-module__RDB_da__icon",
  "option": "select-module-scss-module__RDB_da__option",
  "select": "select-module-scss-module__RDB_da__select",
  "selected": "select-module-scss-module__RDB_da__selected",
  "text": "select-module-scss-module__RDB_da__text",
});
